export default {
  CLEAR: 'clear',
  DEBUG: 'debug',
  MOCK: 'mock',
  MOCK_DELAY: 'mockDelay',
  NSD_API: 'nsdApi',
  SITE: 'site',
  TWILIO_KEYS: 'twilioKeys',
};
